import React from "react";
import InfiniteScrollList from "../../../commonComponents/util/InfiniteScrollList";
import { formatDate, formatCurrency } from "../../../../lib/utils";

export default class ReconciliationCreditsTable extends React.Component {
    
  getCreditsPaginated = async (page, sort, reset = false) =>
    this.props.getCredits(reset, page, this.props.results, sort);

  getTableRow = (transaction) => {
    const selected =
      this.props.selected
        .map(trans => trans.transactionId)
        .indexOf(transaction.transactionId) >= 0;

    return (
      <tr className="table-row" key={transaction.transactionId}>
        <td>
          <div className="custom-check-container">
            <input
              type="checkbox"
              id={`credit-${transaction.transactionId}`}
              onChange={this.props.selectCredit.bind(null, transaction)}
              className="custom-check"
              checked={selected}
            />
            <label
              htmlFor={`credit-${transaction.transactionId}`}
              className="secondary-text"
            />
          </div>
        </td>
        <td data-label="Check">
          <p>{transaction.referenceNumber}</p>
        </td>
        <td data-label="Date">
          <p>{formatDate(transaction.date)}</p>
        </td>
        <td data-label="Description">
          <p>{transaction.details}</p>
        </td>
        <td data-label="Type">
          <p>{transaction.type}</p>
        </td>
        <td data-label="Amount">
          <p>{formatCurrency(transaction.amount, this.props.isIsraeli)}</p>
        </td>
        <td data-label="Note">
          <i
            className={`material-icons ${!selected ? "disabled" : ""}`}
            onClick={() => {
              if (selected) {
                this.props.onClickTransactionNote(transaction.transactionId);
              }
            }}
          >
            {this.props.transactionNotes[transaction.transactionId]
              ? "note"
              : "note_add"}
          </i>
        </td>
      </tr>
    );
  }

  render() {

    const { 
        data: { records, totalCount },
        hasMore,
        loading,
        page,
        results,
        sort,
        success
     } = this.props;
    
    return (
      <InfiniteScrollList
        name="reconciliation credits"
        page={page}
        totalCount={totalCount}
        resultsView={results}
        sort={sort}
        loading={loading}
        success={success}
        renderRecord={this.getTableRow}
        columns={[
            { id: null },
            { title: "Check Number", sortable: true, id: "name" },
            {
              title: "Date",
              sortable: true,
              id: "date",
              defaultDirection: "Ascending"
            },
            { title: "Description", sortable: true, id: "description" },
            { title: "Type", sortable: true, id: "type" },
            { title: "Amount", sortable: true, id: "amount" },
            { title: "Note", sortable: false, id: "note" }
        ]}
        records={records || []}
        hasMore={hasMore}
        showFooter={false}
        getRecords={this.getCreditsPaginated}
        hideScrollToTopButton={true}
      />
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/NewBankReconciliation/ReconciliationCreditsTable.jsx